import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { FullscreenAlert } from "@/shared/ui";

export const FullScreenErrorAlert = (
  props: ComponentProps<typeof FullscreenAlert.Root>,
) => {
  return (
    <FullscreenAlert.Root {...props}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header>
          <FullscreenAlert.Title>{t`Oops! There was an error`}</FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`No worries — our technical team has been notified and will be in touch with a solution. Thanks for your patience!`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel variant="secondary" asChild>
            <Link to={ROUTES.BASE}>{t`Back to Home`}</Link>
          </FullscreenAlert.Cancel>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
